module.exports = __webpack_public_path__ + "static/img/logo.77ffc7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.png
// module id = KItN
// module chunks = 12